define([
	'internal_util/Util',
	'internal_util/X500Util'
], function (
		Util,
		X500Util
		) {
	/**
	 * Origin class
	 * 
	 * @param {string} type AuthenticationOption Type.
	 * @param {string} protocol AuthenticationOption Protocol
	 * @param {Array|string|undefined|null} issuer Attribute issuer(s), X500 name.
	 */
	return function (type, protocol, issuer) {
		var _type,
				_protocol,
				_issuer;

		if (Util.isValidString(type)) {
			_type = type;
		} else {
			throw new Error('invalid authentication option type: ' + type);
		}
		
		if (Util.isValidString(protocol)) {
			_protocol = protocol;
		} else {
			throw new Error('invalid authentication option protocol: ' + protocol);
		}
		
		if (Util.isArray(issuer)) {
			_issuer = issuer;
		} else if (Util.isValidString(issuer)) {
			_issuer = new Array(issuer);
		} else {
			_issuer = new Array();
		}
		
		// public methods

		this.type = function () {
			return _type;
		};

		this.protocol = function () {
			return _protocol;
		};

		/**
		 * Get the issuers.
		 * @returns {Array} Array of strings (X500 names).
		 */
		this.issuer = function () {
			return _issuer;
		};

		this.toObject = function () {
			return {
				type: _type,
				protocol: _protocol,
				issuer: _issuer
			};
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/Origin.js
// module id = 36
// module chunks = 3